module.exports = __webpack_public_path__ + "assets/2887e8f4dd55124da47c191bb8a5bae2.mp3";